import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApplicationInfoService {
  constructor(private http: HttpClient) { }

  getApplicationInfo(): Observable<object> {
    return this.http.get<object>('/application-info');
  }
}
